module.exports = __webpack_public_path__ + "img/ihs-icon.f8a2e537.svg";